import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  return (
    <div className="border p-4 rounded-lg shadow-sm hover:shadow-lg transition">
      <img
        src={product.images?.[0] || "https://via.placeholder.com/300"}
        className="w-full h-48 object-cover rounded"
        alt={product.name}
      />

      <h2 className="text-lg font-semibold mt-3">{product.name}</h2>

      <p className="text-gray-600">₹ {product.price}</p>

      <Link to={`/product/${product._id}`}>
      
        <button className="mt-3 bg-black text-white w-full py-2 rounded">
          View Details
        </button>
      </Link>
    </div>
  );
}
